import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import ViewPendencyButton from 'src/components/common/GenericButtons/Pendency/ViewPendency/ViewPendencyButton';
import WorkflowTradeList from "src/components/Refatoracao/TradeList/WorkflowTradeList";
import PreFraudButton from "src/components/common/PreFraudView/ViewPreFraudButton";

export default function SentPendency(props: RouteComponentProps<any>) {
    const wfStatus = [TradeStatusEnum.PendenciaEnviada];
    const wfPhases = [];
    const cardTitle = "Trades com Pendência Enviadas";

    return (
        <WorkflowTradeList listStatus={wfStatus} listPhase={wfPhases} cardTitle={cardTitle} isArchiveEnabled={true} showArchivedTrades={false}>
            <PreFraudButton />
            <ViewPendencyButton />
        </WorkflowTradeList>
    );
}



// WEBPACK FOOTER //
// ./src/pages/monitor/operacoes/pendencia/SentPendency.page.tsx